import { useSelector } from 'react-redux';
import EnabledToggle from '../formFields/EnabledToggle';
import TrunkDropdown from '../formFields/TrunkDropdown';
import OverstampField from '../formFields/OverstampField';
import LocationField from '../formFields/LocationField';

const BasePlatformNumbersAccordion = ({
    errors,
    touched,
    submitData,
    setSubmitData,
    platformTrunks,
    trunkList,
    trunkCount,
    isTrunkDisabled,
    platformID,
    section,
    isChecked,
    setIsChecked,
    platformLocations,
    locationList,
    locationCount,
    isLocationDisabled = true,
    setSelectedLocation,
    setSelectedTrunk,
    isCurrentTrunkOC = false,
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    const fields = [
        <EnabledToggle
            key={`${section}-enabled-toggle`}
            submitData={submitData}
            setPlatformNumber={setSubmitData}
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            section={section}
            platformID={platformID}
            trunkList={trunkList}
            isTrunkDisabled={isTrunkDisabled}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            setSelectedTrunk={setSelectedTrunk}
            isCurrentTrunkOC={isCurrentTrunkOC}
        />,
        isChecked && !isLocationDisabled && (
            <LocationField
                key={`${section}-location`}
                setPlatformNumber={setSubmitData}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                section={section}
                locations={platformLocations}
                submitData={submitData}
                platformID={platformID}
                locationList={locationList}
                locationCount={locationCount}
                isLocationDisabled={isLocationDisabled}
                setSelectedLocation={setSelectedLocation}
            />
        ),
        isChecked && !isTrunkDisabled && (
            <TrunkDropdown
                key={`${section}-trunk`}
                setPlatformNumber={setSubmitData}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                section={section}
                trunks={platformTrunks}
                submitData={submitData}
                platformID={platformID}
                trunkList={trunkList}
                trunkCount={trunkCount}
                isTrunkDisabled={isTrunkDisabled}
                setSelectedTrunk={setSelectedTrunk}
                isCurrentTrunkOC={isCurrentTrunkOC}
            />
        ),
        isChecked && (
            <OverstampField
                key={`${section}-overstamp`}
                submitData={submitData}
                setPlatformNumber={setSubmitData}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                section={section}
                platformID={platformID}
            />
        ),
    ];
    return fields.filter(Boolean);
};

export default BasePlatformNumbersAccordion;
